import { Link } from "react-router-dom";
import type { Submission } from "@/api/submissions.service";
import { ROUTES } from "@/routes";
import { ContactMatchPill } from "./ContactMatchPill";
import { isLawyerSubmission } from "./contactMatch";
import styles from "./ContactMatch.module.css";

type LawyerCellProps = {
  row: Submission;
};

/**
 * The firm's raw lawyer name, the link state, and the linked Address Book contact.
 * Only lawyer-recommended rows have a lawyer; everything else shows a dash.
 */
export function LawyerCell({ row }: LawyerCellProps) {
  if (!isLawyerSubmission(row)) return <>—</>;

  return (
    <div className={styles.lawyerCell}>
      <span className={styles.lawyerName}>{row.personName || "—"}</span>
      <ContactMatchPill entry={row} />
      {row.contactId && (
        <Link
          to={ROUTES.addressBook.contactDetail(row.contactId)}
          className={styles.contactLink}
          onClick={event => event.stopPropagation()}
          aria-label={`Open linked contact ${row.contactName ?? row.contactId} in the Address Book`}
        >
          {row.contactName ?? "Linked contact"}
        </Link>
      )}
    </div>
  );
}
